import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs, query, orderBy, deleteDoc, doc } from 'firebase/firestore';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';

const AlertsTable = () => {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const fetchAlerts = async () => {
    setLoading(true);
    const q = query(collection(db, 'alerts'), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    setAlerts(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    setLoading(false);
  };

  useEffect(() => {
    fetchAlerts();
  }, []);

  const handleDelete = (id) => {
    setDeleteTarget(id);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    await deleteDoc(doc(db, 'alerts', deleteTarget));
    setDeleteTarget(null);
    fetchAlerts();
  };

  const cancelDelete = () => {
    setDeleteTarget(null);
  };

  if (loading) return <Typography>Loading alerts...</Typography>;
  if (!alerts.length) return <Typography>No alerts found.</Typography>;

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" gutterBottom>Recent Alerts</Typography>
      <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: '0 18px 50px rgba(15, 23, 42, 0.08)', overflowX: 'auto' }}>
        <Table sx={{ minWidth: 600 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: 'rgba(13, 71, 161, 0.08)' }}>
              <TableCell sx={{ backgroundColor: 'rgba(13, 71, 161, 0.08)', fontWeight: 700, whiteSpace: 'nowrap', minWidth: 120 }}>Vehicle ID</TableCell>
              <TableCell sx={{ backgroundColor: 'rgba(13, 71, 161, 0.08)', fontWeight: 700, whiteSpace: 'nowrap', minWidth: 130 }}>Alert Type</TableCell>
              <TableCell sx={{ backgroundColor: 'rgba(13, 71, 161, 0.08)', fontWeight: 700, whiteSpace: 'nowrap', minWidth: 180 }}>Time</TableCell>
              <TableCell sx={{ backgroundColor: 'rgba(13, 71, 161, 0.08)', fontWeight: 700, whiteSpace: 'nowrap', minWidth: 100 }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {alerts.map(alert => (
              <TableRow key={alert.id} sx={{ '&:hover': { backgroundColor: 'action.hover' } }}>
                <TableCell sx={{ whiteSpace: 'nowrap', minWidth: 120 }}>{alert.vehicleId}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', minWidth: 130 }}>{alert.type}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', minWidth: 180 }}>{alert.createdAt?.toDate?.().toLocaleString?.() || '-'}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', minWidth: 100 }}>
                  <Button color="error" size="small" variant="outlined" onClick={() => handleDelete(alert.id)}>
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={Boolean(deleteTarget)} onClose={cancelDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this alert record? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete}>Cancel</Button>
          <Button onClick={confirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AlertsTable;
